/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Teachanimated1Inputs */

const zh_landing_hero_teachanimated1 = /** @type {(inputs: Landing_Hero_Teachanimated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更更更更多`)
};

const en_landing_hero_teachanimated1 = /** @type {(inputs: Landing_Hero_Teachanimated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moooore`)
};

const es_landing_hero_teachanimated1 = /** @type {(inputs: Landing_Hero_Teachanimated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`máaas`)
};

/**
* | output |
* | --- |
* | "moooore" |
*
* @param {Landing_Hero_Teachanimated1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_hero_teachanimated1 = /** @type {((inputs?: Landing_Hero_Teachanimated1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Teachanimated1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_hero_teachanimated1(inputs)
	if (locale === "en") return en_landing_hero_teachanimated1(inputs)
	return es_landing_hero_teachanimated1(inputs)
});
export { landing_hero_teachanimated1 as "landing_hero_teachAnimated" }